<template>
  <div>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="flex h-full">
                <div class="cursor-pointer" :class="[(currentRoute === 'forms') ? 'menu-item-active' : 'menu-item']" @click="select('forms')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">CopyrightAssignmentTransfer Information</div>
                  </div>
                </div>
                <div class="cursor-pointer" :class="[(currentRoute === 'attachments') ? 'menu-item-active' : 'menu-item']" @click="select('attachments')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Attachments</div>
                  </div>
                </div>
                <div class="cursor-pointer" :class="[(currentRoute === 'messages') ? 'menu-item-active' : 'menu-item']" @click="select('messages')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Messages</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <CopyrightAssignmentTransferApplication v-if="currentRoute === 'forms'" :task="task"/>
              <CopyrightAssignmentTransferFormFiles v-if="currentRoute === 'attachments'" :task="task"/>
              <CopyrightAssignmentTransferMessages v-if="currentRoute === 'messages'" :task="task"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import CopyrightAssignmentTransferMessages from "@/views/home/services/copyright-assignment-transfer/task/CopyrightAssignmentTransferMessages.vue";
import CopyrightAssignmentTransferFormFiles from "@/views/home/services/copyright-assignment-transfer/task/CopyrightAssignmentTransferFormFiles.vue";
import CopyrightAssignmentTransferApplication from "@/views/home/services/copyright-assignment-transfer/task/CopyrightAssignmentTransferApplication.vue";
export default {
  name: "CopyrightAssignmentTransferApplicationDetails",
  components: {CopyrightAssignmentTransferApplication, CopyrightAssignmentTransferFormFiles, CopyrightAssignmentTransferMessages},
  props:{
    task:Object
  },
  data(){
    return{
      currentRoute: "forms",
    }
  },
  methods:{
    select(route){
      this.currentRoute = route
    },
  },
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>
